import React from "react";
import "../add_campaign/styles.css";

export default function ExtensionInformation() {
  return (
    <div className="container-info mt-3">
      <div style={{ fontSize: 14, fontWeight: "600" }}>Keterangan</div>
      <div style={{ marginTop: 24 }}>
        <div className="d-flex">
          <div style={{ flex: 1 }}>1.</div>
          <div style={{ flex: 20 }}>
          Untuk membuat promo baru, harus ada reguler offer terlebih dahulu
            untuk kategori produk, cabang, jenis pembayaran, jenis tenor, dan
            juga tenor yang akan dibuat.
          </div>
        </div>
        <div className="d-flex">
          <div style={{ flex: 1 }}>2.</div>
          <div style={{ flex: 20 }}>
          Minimal Pinjaman adalah syarat nilai pinjaman terendah untuk mendapatkan promo.
          </div>
        </div>
        <div className="d-flex">
          <div style={{ flex: 1 }}>3.</div>
          <div style={{ flex: 20 }}>
          Nilai Revaluasi adalah jumlah uang yang harus diberikan oleh nasabah untuk mengurangi jumlah hutang/tagihan nasabah tersebut.
          </div>
        </div>

      </div>
    </div>
  );
}
